<template>
  <div class="content-wrapper">
    <Loader v-if="!plan.name" />
    <section v-if="plan.name" class="plan-info">
      <h2 class="impact-light plan-count">
        Plan: <strong>{{ plan.name }}</strong>
      </h2>
      <h2 v-if="planAdmin && !isUnlimitedCredit" class="light">
        {{ $t("plan.planHome.credits") }}:
        <strong class="error">{{ credits }}</strong>
      </h2>
      <h2 v-if="planAdmin && isUnlimitedCredit" class="light">
        {{ $t("plan.planHome.graphs") }}:
        <strong class="error">{{ graphs }}</strong>
      </h2>
      <p v-if="planAdmin && !isUnlimitedCredit">
        {{ $t("plan.planHome.text") }}
      </p>
      <p v-if="!plan.enabled" class="error">
        {{ $t("plan.planHome.infoMsg") }}
      </p>
    </section>

    <Loader v-if="!groupsLoaded || !creditsLoaded" />
    <h2 v-if="groupsLoaded && creditsLoaded" class="light group-count">
      Groups: <strong>{{ groups.length }}</strong>
    </h2>
    <section v-if="groupsLoaded && creditsLoaded" class="cta-wrapper">
      <GroupBlock
        v-for="(group, index) in groups"
        v-bind:key="index"
        v-bind:group="group"
        v-bind:credits="credits"
        v-bind:planAdmin="planAdmin"
        v-bind:planEnabled="plan.enabled"
        v-bind:isUnlimitedCredit="isUnlimitedCredit"
      />
      <GroupCreateBlock
        v-if="planAdmin && plan.enabled"
        v-bind:planId="planId"
      />
    </section>

    <PlanAdmins
      v-if="planAdmin && planId"
      v-bind:planId="planId"
      v-bind:enabled="plan.enabled"
    />
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import GroupBlock from "@/components/plan/GroupBlock.vue";
import GroupCreateBlock from "@/components/plan/GroupCreateBlock.vue";
import PlanAdmins from "@/components/plan/PlanAdmins.vue";

import { planService } from "@/services/plan.service";
import { groupService } from "@/services/group.service";

export default {
  name: "PlanHome",
  components: {
    Loader,
    GroupBlock,
    GroupCreateBlock,
    PlanAdmins,
  },
  data() {
    return {
      user: {},
      planAdmin: true,
      showModal: false,
      planId: 0,
      plan: {},
      credits: 0,
      groups: [],
      groupsLoaded: false,
      creditsLoaded: false,
      isUnlimitedCredit: false,
      graphs: 0,
    };
  },
  mounted: function() {
    // grab the user
    let user = JSON.parse(localStorage.getItem("user"));
    this.user = user.userInfo;

    this.planId = this.$route.params.planId;

    this.fetchPlan();
  },
  methods: {
    fetchPlan: function() {
      // grab the plan
      planService
        .getPlan(this.planId)
        .then((plan) => {
          this.plan = plan;
          this.isUnlimitedCredit = plan.unlimitedCredit;
          if (plan.description) {
            this.plan.description = decodeURIComponent(atob(plan.description));
          }
          if (this.user.userType === 0 && !plan.enabled) {
            this.$router.push("/plans");
          } else {
            this.fetchCredits();
            this.fetchGroups();
            this.$forceUpdate();
          }
        })
        .catch((err) => {
          if (err == "User does not have permission for plan") {
            this.planAdmin = false;
            planService
              .getPlanByMember(this.planId)
              .then((plan) => {
                this.plan = plan;
                if (plan.description) {
                  this.plan.description = decodeURIComponent(
                    atob(plan.description)
                  );
                }
                if (!plan.enabled) {
                  this.$router.push("/plans");
                }
              })
              .catch((err) => {
                console.error("Something went wrong fetching plan: ", err);
              });
            this.fetchCreditsByOwner();
            this.ownGroups();
          } else {
            console.error("Something went wrong fetching plan: ", err);
          }
        });
    },
    fetchCredits: function() {
      // Get credits for the plan
      planService
        .meter(this.planId)
        .then((meter) => {
          this.credits = meter.currentValue;
          this.creditsLoaded = true;
          this.$forceUpdate();
        })
        .catch((err) => {
          console.error("Something went wrong fetching credits: ", err);
        });
    },
    fetchGroups: function() {
      // Grab the groups (groups) for this plan.
      planService
        .getGroups(this.planId)
        .then((groups) => {
          let unarchivedGroups = [];
          for (let group of groups) {
            if (group.enabled) {
              if (group.description) {
                group.description = decodeURIComponent(atob(group.description));
              }
              unarchivedGroups.push(group);
            }
          }
          this.groups = unarchivedGroups;
          this.groupsLoaded = true;
          this.$forceUpdate();
        })
        .catch((err) => {
          console.error("Something went wrong fetching groups: ", err);
        });
    },
    ownGroups: function() {
      groupService
        .getGroups()
        .then((groups) => {
          this.parseMemberGroups(groups);
          this.groupsLoaded = true;
          this.$forceUpdate();
        })
        .catch((err) => {
          console.error("Something went wrong fetching own groups: ", err);
        });
    },
    parseMemberGroups: function(groups) {
      for (let group of groups) {
        if (group.planId === Number(this.planId)) {
          this.plan.name = group.planName;
          if (group.description) {
            group.description = decodeURIComponent(atob(group.description));
          }
          this.groups.push(group);
        }
      }
    },
    fetchCreditsByOwner: function() {
      // Get credits for the plan by Group Admin
      planService
        .meterByOwner(this.planId)
        .then((meter) => {
          this.credits = meter.currentValue;
          this.creditsLoaded = true;
          this.$forceUpdate();
        })
        .catch((err) => {
          console.error(
            "Something went wrong fetching credits by Group Admin: ",
            err
          );
        });
    },
    fetchMeterEvent: function() {
      planService.meterEvents(this.planId).then((data) => {
        this.graphs = data.filter((me) => me.type === "Consumption").length;
      });
    },
  },
  watch: {
    isUnlimitedCredit(newVal) {
      if (newVal === true) {
        this.fetchMeterEvent();
      }
    },
  },
};
</script>

<style lang="scss">
.content-wrapper {
  .welcome {
    margin-bottom: 60px;
  }
}

section.plan-info {
  margin-bottom: 85px;
}
</style>
